import { render, staticRenderFns } from "./AddChecklist.vue?vue&type=template&id=35468f8c&scoped=true"
import script from "./AddChecklist.vue?vue&type=script&lang=js"
export * from "./AddChecklist.vue?vue&type=script&lang=js"
import style0 from "./AddChecklist.vue?vue&type=style&index=0&id=35468f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35468f8c",
  null
  
)

export default component.exports